export const getConfig = (key?: string, defaultValue?: any) => {
  const configuration = global.window.__CONFIG__ || {};
  if (!key) {
    return configuration;
  }
  return defaultValue;
};
